import { WithStyles, withStyles } from '@mui/styles';

import { PendingSetup } from './pendingSetup';
import { muiStyles } from './styles';

export type PendingSetupProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(PendingSetup);